import { STATUS_VARIANTS } from 'components/Tags/Status/styled';

export const statusTheme = {
  [STATUS_VARIANTS.ERROR]: 'palette.error.60',
  [STATUS_VARIANTS.NEUTRAL]: 'palette.neutral.50',
  [STATUS_VARIANTS.PRIMARY]: 'palette.tertiary.60',
  [STATUS_VARIANTS.SUCCESS]: 'palette.success.70',
  [STATUS_VARIANTS.WARNING]: 'palette.warning.60',
};
